exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ck-editor__editable_inline {\n  height: 150px !important;\n  border: 1px #EBEBE4 solid !important;\n}", ""]);

// exports
